var _a, _b, _c, _d, _e, _f, _g, _h;
import { __awaiter, __decorate, __metadata } from "tslib";
import axios from "axios";
import { retrocycle } from "@/store/modules/infra/resolveReferences";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import router from "@/router";
import { Actions, InterceptorActions, Mutations } from "@/store/enums/StoreEnums";
let InterceptorModule = class InterceptorModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.unableLoading = false;
        this._warnings = [];
    }
    get loadingActive() {
        return this.loading;
    }
    get warnings() {
        return this._warnings;
    }
    [_a = Mutations.SET_LOADING](isLoading) {
        this.loading = isLoading;
    }
    [_b = Mutations.ADD_WARNING](warnings) {
        warnings.forEach((warning) => {
            const exists = this._warnings.some(existingWarning => existingWarning.text === warning.text && existingWarning.type === warning.type);
            if (!exists) {
                this._warnings.unshift(warning);
            }
        });
    }
    [_c = Mutations.UNABLE_LOADING](unable) {
        this.unableLoading = unable;
    }
    [_d = Mutations.CLEAR_WARNING](warningId) {
        const index = this._warnings.findIndex(warning => warning.id === warningId);
        if (index !== -1) {
            this._warnings.splice(index, 1);
        }
    }
    [_e = Actions.SET_LOADING_TOGGLE](isLoading) {
        this.context.commit(Mutations.SET_LOADING, isLoading);
    }
    [_f = Actions.SET_UNABLE_LOADING](unable) {
        this.context.commit(Mutations.UNABLE_LOADING, unable);
    }
    [_g = InterceptorActions.DELETE_WARNING](warningId) {
        this.context.commit(Mutations.CLEAR_WARNING, warningId);
    }
    [_h = InterceptorActions.INIT]() {
        return __awaiter(this, void 0, void 0, function* () {
            let requestCounter = 0;
            const isValidJSON = str => {
                try {
                    JSON.parse(str);
                    return true;
                }
                catch (e) {
                    return false;
                }
            };
            const cleanData = (data) => {
                if (typeof data === "string" && isValidJSON(data)) {
                    data = JSON.parse(data);
                }
                if (Array.isArray(data)) {
                    return data.map(item => cleanData(item));
                }
                if (typeof data == 'string')
                    return data;
                const propsToClean = [
                    "$id",
                    "data_Criacao",
                    "data_Alteracao",
                    "usuario_Criacao_Id",
                    "usuario_Criacao",
                    "usuario_Alteracao_Id",
                    "usuario_Alteracao",
                    "unidade",
                    "unidade_Id"
                ];
                Object.keys(data).forEach(prop => {
                    if (propsToClean.includes(prop)) {
                        delete data[prop];
                    }
                    else if (Array.isArray(data[prop])) {
                        data[prop] = data[prop].map((item) => cleanData(item));
                    }
                    else if (typeof data[prop] === "object" && data[prop] !== null) {
                        data[prop] = cleanData(data[prop]);
                    }
                });
                return data;
            };
            const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
            axios.interceptors.request.use(request => {
                if ((request.method == "post" || request.method == "put") &&
                    !["usuario", "unidade", "informativo"].some(exclude => { var _j; return (_j = request.url) === null || _j === void 0 ? void 0 : _j.toLowerCase().includes(exclude); })
                    && request.data != null && request.data != 'undefined') {
                    request.data = cleanData(request.data);
                }
                requestCounter++;
                if (requestCounter >= 1 && !this.unableLoading) {
                    this.context.commit(Mutations.SET_LOADING, true);
                }
                return request;
            });
            axios.interceptors.response.use((response) => __awaiter(this, void 0, void 0, function* () {
                var _j;
                retrocycle(response.data);
                requestCounter--;
                if ((_j = response.data) === null || _j === void 0 ? void 0 : _j.warning) {
                    const _warnings = response.data.warning.map(item => {
                        if (item.id == null)
                            item.id = Math.round(Math.random() * 999999);
                        return item;
                    });
                    this.context.commit(Mutations.ADD_WARNING, _warnings);
                }
                if (requestCounter === 0) {
                    yield delay(200);
                    if (requestCounter === 0) {
                        this.context.commit(Mutations.SET_LOADING, false);
                    }
                }
                return response;
            }), (error) => __awaiter(this, void 0, void 0, function* () {
                const defaultResponse = {
                    data: { errors: ["Erro desconhecido. Tente novamente mais tarde."] },
                    status: 500,
                    statusText: "Erro Interno do Servidor",
                    headers: {},
                    config: error.config || {},
                };
                if (!error.response) {
                    this.context.commit(Mutations.ADD_WARNING, [{
                            id: Math.round(Math.random() * 999999),
                            text: "Erro na comunicação com o servidor. Tente novamente mais tarde.",
                            type: 3
                        }]);
                    requestCounter--;
                    if (requestCounter === 0) {
                        yield delay(200);
                        if (requestCounter === 0) {
                            this.context.commit(Mutations.SET_LOADING, false);
                        }
                    }
                    return Promise.reject(Object.assign(Object.assign({}, error), { response: defaultResponse }));
                }
                if (error.response.status >= 400) {
                    let signInPath = { path: "/sign-in" };
                    const routerData = router.currentRoute.value;
                    if (routerData.path !== "/" && !["sign-in", "sign-up", "password-reset", "definirSenha", "home"].includes(routerData.name))
                        signInPath.path += `/${btoa(routerData.fullPath)}`;
                    if (routerData.name === "sign-in") {
                        signInPath.path = routerData.fullPath;
                    }
                    router.push(signInPath);
                }
                else {
                    requestCounter--;
                    if (requestCounter === 0) {
                        yield delay(200);
                        if (requestCounter === 0) {
                            this.context.commit(Mutations.SET_LOADING, false);
                        }
                    }
                }
                return Promise.reject(error);
            }));
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], InterceptorModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], InterceptorModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], InterceptorModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], InterceptorModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], InterceptorModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], InterceptorModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], InterceptorModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], InterceptorModule.prototype, _h, null);
InterceptorModule = __decorate([
    Module
], InterceptorModule);
export default InterceptorModule;
//# sourceMappingURL=InterceptorModule.js.map